import { getCookieConsentValue } from "react-cookie-consent";

declare global {
    interface Window {
        dataLayer: Record<string, unknown>[];
    }
}

export const CONSENT_COOKIE_NAME = "nwt_consent_status";

export const triggerGtmConsent = (status: "granted" | "denied") => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "consent_confirmed",
        analytics_storage: status,
    });
};

export const getGa4ClientId = (): string | null => {
    const match = document.cookie.match(/(?:^|;\s*)_ga=GA\d+\.\d+\.(.+?)(?:;|$)/);
    return match ? match[1] : null;
};

export const getGa4SessionId = (): string | null => {
    const match = document.cookie.match(/(?:^|;\s*)_ga_[A-Z0-9]+=GS\d+\.\d+\.s?(\d+)/);
    return match ? match[1] : null;
};

export const getConsentStatus = (): "granted" | "denied" => {
    return getCookieConsentValue(CONSENT_COOKIE_NAME) === "true" ? "granted" : "denied";
};

export const appendTrackingParams = (url: string): string => {
    const parsed = new URL(url);
    const consent = getConsentStatus();
    if (consent === "granted") {
        const gaClientId = getGa4ClientId();
        if (gaClientId) {
            parsed.searchParams.set("ga_id", gaClientId);
        }
        const gaSessionId = getGa4SessionId();
        if (gaSessionId) {
            parsed.searchParams.set("session_id", gaSessionId);
        }
    }
    parsed.searchParams.set("consent", consent);
    return parsed.toString();
};
